import { render, staticRenderFns } from "./QualityList.vue?vue&type=template&id=2c993c00&scoped=true"
import script from "./QualityList.vue?vue&type=script&lang=js"
export * from "./QualityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c993c00",
  null
  
)

export default component.exports